// Chakra Imports
import {
  Button,
  Box,
  Flex,
  Text,
  Image,
  useColorModeValue,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  SimpleGrid,
  DrawerOverlay,
  Stack,
  useToast,
  Icon,
  Input,
} from '@chakra-ui/react';
import { useState } from 'react';
import { MdUpload } from "react-icons/md";
import { useDropzone } from 'react-dropzone';

import { HSeparator } from '../../../../components/separator/Separator';
import InputField from '../../../../components/fields/InputField';
import SwitchField from '../../../../components/fields/SwitchField';
import ConfiguratorLogo from '../../../../assets/img/layout/ConfiguratorLogo.png';
// import { createUserAccess } from '../hooks';
import { LoadingSpinner } from '../../../../constants/helper';
import { updateLuggage } from '../hooks';
// import Dropzone from './Dropzone';

export default function DeliverLuggage(props) {
  const { setOpenCreateAccess, openCreateAccess, luggageId, setFetchApi} = props;
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  // Chakra Color Mode
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const bgSeparator = useColorModeValue('secondaryGray.400', '#323B5D');
  const drawerBg = useColorModeValue('white', 'navy.800');
  const brandColor = useColorModeValue("brand.500", "white");

    const bg = useColorModeValue('gray.100', 'navy.700');
    const borderColor = useColorModeValue('secondaryGray.100', 'whiteAlpha.100');

  const configuratorShadow = useColorModeValue(
    '-20px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '-22px 32px 51px 4px #0B1437',
  );

    const [values, setValues] = useState({
      luggageId: luggageId,
      name: "",
      phone: "",
      images: [], // <-- multiple images
      isCustomerReceived: false,
    });

    const [errors, setErrors] = useState(values);
  
    const handleChange = (e) => {
      setValues({ ...values, [e.target.name]: e.target.value });
    }
    const validate = () => {
      let temp = {};
      temp.name = values.name || values?.isCustomerReceived ? "" : "Name is required.";
      temp.phone = values.phone || values?.isCustomerReceived ? "" : "Phone is required.";
  
      setErrors({
        ...temp,
      });
  
      return Object.values(temp).every((x) => x === "");
    };

    const onUploadImage = (acceptedFiles) => {
      if (!acceptedFiles.length) return;
    
      const file = acceptedFiles[0]; // Get the first file
      let { name, size, type } = file;
    
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const extensions = ['jpeg', 'png', 'gif', 'tiff', 'psd', 'jpg'];
      const k = 1024;
      const i = Math.floor(Math.log(size) / Math.log(k));
      const actualsize = parseFloat((size / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    
      if (size > 9437184 ) {  //9 * 1024 * 1024 = 9MB limit
        return toast({
          title: "Error",
          description: `Can't upload image larger than 9MB. Your image size is ${actualsize}`,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "top-right",
        });
      }
    
      const extension = name.split('.').pop().toLowerCase();
      if (!extensions.includes(extension)) {
        return toast({
          title: "Error",
          description: "Only images are allowed",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "top-right",
        });
      }
    
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setValues((prev) => ({
          ...prev,
          images: [
            ...prev.images,
            {
              data: reader.result,
              name,
              type,
              size: actualsize,
            },
          ],
        }));
        setLoading(false);
      };
    };

    const { getRootProps, getInputProps } = useDropzone({
      onDrop: onUploadImage,
      accept: "image/*",
    });
    
    // Remove image handler
    const handleRemoveImage = (index) => {
      setValues((prev) => ({
        ...prev,
        images: prev.images.filter((_, i) => i !== index),
      }));
    };

    const handleSubmit = async () => {
      if(validate()){
        setLoading(true);
        try {
          console.log(values);
          let res = await updateLuggage(values);
          if (res.success) {
            toast({
              title: "Luggague Status update successfully.",
              status: "success", // could be success, error, or info
              duration: 5000, // time in ms before the toast disappears
              isClosable: true, // allows user to manually close the toast
              position: "top-right",
            });
            setOpenCreateAccess(false);
            setFetchApi((prev) => !prev);
          }
          else {
            toast({
              title: "Error",
              description: `${res?.data}`,
              status: "error", // could be success, error, or info
              duration: 5000, // time in ms before the toast disappears
              isClosable: true, // allows user to manually close the toast
              position: "top-right",
            });
          }
        }
        catch (err) {
          toast({
            title: "Error",
            description: `${err}`,
            status: "error", // could be success, error, or info
            duration: 5000, // time in ms before the toast disappears
            isClosable: true, // allows user to manually close the toast
            position: "top-right",
          });
        }
        finally {
          setLoading(false);
        }
      }
    }

  return (
    <>
      <Drawer
        isOpen={openCreateAccess}
        onClose={() => setOpenCreateAccess(false)}
        placement={document.documentElement.dir === 'rtl' ? 'left' : 'right'}
        blockScrollOnMount={false}
      >
        <DrawerOverlay />
        <DrawerContent
          boxShadow={configuratorShadow}
          w={{ base: 'calc(100vw - 32px)', md: '400px' }}
          maxW={{ base: 'calc(100vw - 32px)', md: '400px' }}
          ms={{
            base: '0px',
            sm: '16px',
          }}
          me={{
            base: '16px',
          }}
          my={{
            sm: '16px',
          }}
          borderRadius="16px"
          bg={drawerBg}
        >
          {loading ? <LoadingSpinner /> : 
        <>
          <DrawerHeader
            w={{ base: '100%', md: '400px' }}
            pt="24px"
            pb="0px"
            px="24px"
          >
            <DrawerCloseButton color={textColor} />
            <Flex alignItems="center">
              <Flex
                h="48px"
                w="48px"
                me="20px"
                borderRadius="999px"
                bgGradient="linear(to-b, brand.400, brand.600)"
              >
                <Image src={ConfiguratorLogo} />
              </Flex>
              <Box>
                <Text color={textColor} fontSize="xl" fontWeight="700">
                 Deliver Luggage
                </Text>
                <Text
                  display={'flex'}
                  color="secondaryGray.600"
                  fontSize="md"
                  fontWeight="500"
                >
                  given to the customer
                </Text>
              </Box>
            </Flex>
            <HSeparator my="30px" bg={bgSeparator} />
          </DrawerHeader>
          <DrawerBody
            pt="0px"
            pb="24px"
            w={{ base: '100%', md: '400px' }}
            maxW="unset"
          >
            <Flex direction="column" gap="20px">
              {/* Upload Box */}
              <Flex
                align="center"
                justify="center"
                bg={bg}
                border="1px dashed"
                borderColor={borderColor}
                borderRadius="16px"
                w="100%"
                h="180px"
                minH="180px"
                cursor="pointer"
                {...getRootProps()}
              >
                <Input type="file" {...getInputProps()} />
                {loading ? (
                  <LoadingSpinner />
                ) : (
                  <Button variant="no-effects">
                    <Box textAlign="center">
                      <Icon as={MdUpload} w="60px" h="60px" color={brandColor} />
                      <Flex justify="center" mx="auto" mb="8px">
                        <Text fontSize="md" fontWeight="700" color={brandColor}>
                          Upload Image
                        </Text>
                      </Flex>
                      <Text fontSize="sm" fontWeight="500" color="secondaryGray.500">
                        PNG, JPG (Max 9MB)
                      </Text>
                    </Box>
                  </Button>
                )}
              </Flex>

              {/* Image Preview Grid */}
              {values.images.length > 0 && (
                <SimpleGrid columns={{ base: 2, md: 3 }} spacing="15px" mt="10px">
                  {values.images.map((img, index) => (
                    <Box
                      key={index}
                      position="relative"
                      borderRadius="12px"
                      overflow="hidden"
                      boxShadow="md"
                    >
                      <Image
                        src={img.data}
                        alt={`upload-${index}`}
                        objectFit="cover"
                        w="100%"
                        h="120px"
                        borderRadius="12px"
                      />
                      <Button
                        size="xs"
                        colorScheme="red"
                        position="absolute"
                        top="6px"
                        right="6px"
                        onClick={() => handleRemoveImage(index)}
                      >
                        ✕
                      </Button>
                    </Box>
                  ))}
                </SimpleGrid>
              )}
            </Flex>

            <Flex direction="column" w="100%" mt="20px">
              <SwitchField
                isChecked={values?.isCustomerReceived}
                reversed={true}
                fontSize='sm'
                mb='20px'
                id='1'
                label='Customer has received the luggage'
                onChange={() => setValues((prev) => ({
                  ...prev,
                  isCustomerReceived: !prev.isCustomerReceived, 
                }))}
              />
              {!values?.isCustomerReceived ? (
                <Stack direction="column" spacing="20px">
                  <SimpleGrid rows={{ base: 1, md: 2 }} gap="20px">
                    <InputField
                      mb="0px"
                      id="name"
                      placeholder="eg. test45"
                      label="Recipient Name"
                      name="name"
                      onChange={handleChange}
                      error={errors.name}
                    />
                    <InputField
                      mb="0px"
                      id="phone"
                      label="Recipient Phone"
                      name="phone"
                      error={errors.phone}
                      onChange={handleChange}
                    />
                  </SimpleGrid>
                </Stack>
              ) : null}
              <HSeparator my="30px" bg={bgSeparator} />
              <Flex justify="space-between" mt="10px">
                <Button
                  variant="light"
                  fontSize="sm"
                  borderRadius="16px"
                  w={{ base: '100px', md: '118px' }}
                  h="46px"
                  ms="auto"
                  onClick={() => setOpenCreateAccess(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="darkBrand"
                  fontSize="sm"
                  borderRadius="16px"
                  w={{ base: '100px', md: '118px' }}
                  h="46px"
                  ms="auto"
                  onClick={handleSubmit}
                >
                  Save
                </Button>
              </Flex>
            </Flex>
          </DrawerBody>
          </>
        }   
        </DrawerContent>
      </Drawer>
    </>
  );
}
